import { render, staticRenderFns } from "./TheConsent.vue?vue&type=template&id=69adb745"
import script from "./TheConsent.vue?vue&type=script&lang=js"
export * from "./TheConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports